export default __webpack_public_path__ + "static/media/Typing.734f5ef5.png";